/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, EffectFade, A11y,FreeMode,Thumbs,Parallax,Autoplay} from 'swiper/modules';

(($) => {

    //Hero Slideshows
    const heroSlides = document.querySelectorAll('.js-home-slideshow');
    heroSlides.forEach((hero, index) => {

        let slider = hero;
        let prev = hero.querySelector('.swiper-button-prev');
        let next = hero.querySelector('.swiper-button-next');
        let autoplaySpeed = slider.getAttribute('data-autoplay-speed') || 5000;

        const heroGallery = new Swiper(slider, {
            modules: [Navigation,A11y,Parallax,Autoplay],
            loop: true,
            speed: 1000,
            parallax: true,
            a11y: {
                enabled: true,
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
            autoplay:{
                delay: parseInt(autoplaySpeed, 10),
                disableOnInteraction: false
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                1024: {
                    speed: 1500,
                }
            }
        });

    });

    //INTERIOR GALLERY w/ THUMBNAILS
    const galleries = document.querySelectorAll('.gallery');
    galleries.forEach((gallery, index) => {

        let slider = gallery.querySelector('.js-gallery-slides');
        let thumbs = gallery.querySelector('.js-gallery-thumbs');
        let prev = gallery.querySelector('.swiper-button-prev');
        let next = gallery.querySelector('.swiper-button-next');

        const galleryThumbs = new Swiper(thumbs, {
            modules: [FreeMode,A11y],
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesProgress: true,
        });

        const galleryTop = new Swiper(slider, {
            modules: [EffectFade,Navigation,A11y,Thumbs],
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });

    });
    

})(jQuery)